import React from "react";
import YouTubeVideo from "components/YouTubeVideo";
import MediaDialog, { IMediaDialogProps } from "./MediaDialog";

interface IProps extends IMediaDialogProps {
    videoId: string;
}

export default function VideoDialog(props: IProps) {
    const { videoId, ...rest } = props;

    return (
        <MediaDialog {...rest}>
            <YouTubeVideo videoId={videoId} />
        </MediaDialog>
    );
}
